module.exports = __webpack_public_path__ + "static/media/DiningMenuItem.96488533.png";